var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocumentScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 5.99984V0.166504H6.16537V2.49984H2.66536V5.99984H0.332031ZM21.332 5.99984V2.49984H17.832V0.166504H23.6654V5.99984H21.332ZM0.332031 25.8332V19.9998H2.66536V23.4998H6.16537V25.8332H0.332031ZM17.832 25.8332V23.4998H21.332V19.9998H23.6654V25.8332H17.832ZM6.16537 19.9998H17.832V5.99984H6.16537V19.9998ZM6.16537 22.3332C5.5237 22.3332 4.97459 22.1049 4.51803 21.6483C4.0607 21.191 3.83203 20.6415 3.83203 19.9998V5.99984C3.83203 5.35817 4.0607 4.80906 4.51803 4.3525C4.97459 3.89517 5.5237 3.6665 6.16537 3.6665H17.832C18.4737 3.6665 19.0232 3.89517 19.4805 4.3525C19.9371 4.80906 20.1654 5.35817 20.1654 5.99984V19.9998C20.1654 20.6415 19.9371 21.191 19.4805 21.6483C19.0232 22.1049 18.4737 22.3332 17.832 22.3332H6.16537ZM8.4987 10.6665H15.4987V8.33317H8.4987V10.6665ZM8.4987 14.1665H15.4987V11.8332H8.4987V14.1665ZM8.4987 17.6665H15.4987V15.3332H8.4987V17.6665Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentScanner);
export default __webpack_public_path__ + "static/media/icon_document_scanner.ac153e9c44697a3bb4eeb6b60484255a.svg";
export { ForwardRef as ReactComponent };